import { render, staticRenderFns } from "./dounght.md?vue&type=template&id=d4f3530c&"
import script from "./dounght.md?vue&type=script&lang=js&"
export * from "./dounght.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4f3530c')) {
      api.createRecord('d4f3530c', component.options)
    } else {
      api.reload('d4f3530c', component.options)
    }
    module.hot.accept("./dounght.md?vue&type=template&id=d4f3530c&", function () {
      api.rerender('d4f3530c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Pie/dounght.md"
export default component.exports